import Navigation from "@/HomeFeatures/Navigation";
import Image from "next/image";
import Images, { Icons } from "@/app/assets/assets";
import { formatDateWithOrdinal } from "@/lib/FormatDate";
import { cleanText, parseBrokenTitle } from "@/lib/Utility";
interface Props {
    survey: any;
    handlePrev: () => void;
    handleNext: () => void;
    surveyId: number;
}
const SurveyBannerSection = ({ survey, handlePrev, handleNext, surveyId }: Props) => {

    const { ClientName, Designation, CompanyName } = parseBrokenTitle(survey?.title,);
    return (
        <section className="relative h-[max-content]">
            <div className="relative z-10 w-full h-full">
                <div className="w-full h-full flex flex-col pb-[100px] ">
                    <div className="absolute inset-0 z-0">
                        <Image
                            src={Images?.resourcebg}
                            alt="texture"
                            fill
                            className="object-cover mix-blend-overlay"
                            priority
                            sizes="(max-width: 768px) 100vw, (max-width: 1536px) 50vw, 700px"
                        />
                    </div>
                    <Navigation />

                    <div className="flex max-w-[2500px] flex-col mx-auto w-[calc(100vw_-_10%)] relative">
                        <h1
                            className="self-stretch pt-[75px] text-left max-w-[22ch] justify-start text-white 
                   text-[clamp(2.25rem,1.84rem+1.8224vw,4.6875rem)] font-normal 
                   clash-font capitalize leading-[100%]"
                        >
                            Interview with {ClientName} Director of{" "}
                            <span className="text-[#225BD4]"> {Designation}</span> at{" "}
                            <span className="text-[#225BD4]">{CompanyName}</span>
                        </h1>

                        <p className="text-[rgba(148,149,150,1)] text-left py-5">
                            on {formatDateWithOrdinal(survey.reviewDate)}
                        </p>

                        <div className="px-6 py-1.5 bg-gradient-to-b w-max-full lg:w-max from-white/5 to-white/0 rounded-[41px] outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-center items-center gap-2.5">
                            <p className="text-center justify-start text-white text-lg font-normal leading-[150%] tracking-tight break-words">
                                {cleanText(survey.smallOverview)}
                            </p>
                        </div>

                        <div className="flex items-center gap-4 py-10 text-[#949596]">
                            <p>Validated by:</p>
                            <Image
                                src={Icons?.clutch}
                                alt="logo"
                                width={80}
                                height={80}
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                className="grayscale contrast-[0] opacity-45 object-contain"
                            />
                        </div>

                        {/* Carousel Buttons UI */}
                        <div className="technology-tab-switch flex gap-[10px] w-[max-content] mb-2 absolute bottom-8 right-8">
                            <button
                                className="cursor-pointer disabled:opacity-40"
                                aria-label="Previous slide"
                                onClick={handlePrev}
                                disabled={surveyId <= 1}
                            >
                                <Image
                                    src={Icons?.slideLeft as any}
                                    alt="Arrow left"
                                    width={40}
                                    height={40}
                                    className="w-[40px] h-[40px]"
                                    style={{ width: "auto", height: "auto" }}
                                />
                            </button>
                            <button
                                className="cursor-pointer"
                                onClick={handleNext}
                                aria-label="Next slide"
                            >
                                <Image
                                    src={Icons?.slideRight as any}
                                    alt="Arrow right"
                                    width={40}
                                    height={40}
                                    className="w-[40px] h-[40px]"
                                    style={{ width: "auto", height: "auto" }}
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SurveyBannerSection